import { reactive } from '@vue/composition-api';
import { createContext } from '@berlin-front/common/composables/context';
import type { ContextValueType } from '@berlin-front/common/composables/context';
import { broadcast } from '@/broadcast';

export const useSpappLoginFailContext = () => {
  const cancelClick = () => {
    broadcast.send({
      type: 'MODAL_CONTROL_FAILED',
      payload: {},
    });
  };

  const APP_STORE_DOWNLOAD_URL = process.env.VUE_APP_ATONE_APP_STORE_DOWNLOAD_URL;
  const GOOGLE_PLAY_DOWNLOAD_URL = process.env.VUE_APP_ATONE_GOOGLE_PLAY_DOWNLOAD_URL;

  return reactive({
    // 関数
    cancelClick,
    // 表示項目
    APP_STORE_DOWNLOAD_URL,
    GOOGLE_PLAY_DOWNLOAD_URL,
  });
};

export const SpappLoginFailContext = createContext({ useSpappLoginFailContext });
export type SpappLoginFailContextType = ContextValueType<typeof SpappLoginFailContext>;
